<template>
  <b-modal id="e-habilitacao-impressao-documentos"
           ref="e-habilitacao-impressao-documentos"
           centered
           size="md"
           hide-footer
           title="Selecione o que deseja imprimir:">
    <div>
      <b-form-checkbox
        v-model="selectAll"
        switch
        :value="true"
        @change="setSelectAll">
        Selecionar todos
      </b-form-checkbox>
    </div>

    <div class="mt-2">
      <b>Documentos</b>
      <hr class="mt-0 ModalImpressao--border">
      <div v-for="(doc, index) in documentos"
           :key="`documento_${ index }`">
        <b-form-checkbox
          v-model="doc.selected"
          switch
          :value="true"
          @change="verifySelectAll()">
          {{ getName(doc.tag) }}
        </b-form-checkbox>
      </div>
    </div>

    <div class="mt-2">
      <b>Certidões</b>
      <hr class="mt-0 ModalImpressao--border">
      <div v-for="(certidao, index) in certidoes"
           :key="`certidao_${ index }`">
        <b-form-checkbox
          v-model="certidao.selected"
          switch
          :value="true"
          @change="verifySelectAll()">
          {{ getName(certidao.tag) }}
        </b-form-checkbox>
      </div>
    </div>

    <template modal-footer>
      <div class="row">
        <div class="col text-right">
          <b-button class="mr-2"
                    variant="light"
                    @click="$bvModal.hide('e-habilitacao-impressao-documentos')">
            Voltar
          </b-button>

          <b-button @click="imprimir">
            Imprimir
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
  export default {
    name: "ModalImpressao",
    props: {
      propDocumentos: {
        type: Array,
        default: () => ([])
      },
      propCertidoes: {
        type: Array,
        default: () => ([])
      },
      // ao inves de passar a propHabilitacao
      // passando apenas o resultado da condicao
      propCumprimento: {
        type: Boolean,
        default: () => false
      }
    },
    data () {
      return {
        selectAll: true,
        documentos: [ ...this.mapSelected(this.propDocumentos, true)],
        certidoes: [ ...this.mapSelected(this.propCertidoes, true) ]
      }
    },
    watch: {
      propDocumentos () {
        this.documentos = [ ...this.propDocumentos ]
      },

      propCertidoes () {
        this.certidoes = [ ...this.propCertidoes ]
      }
    },
    methods: {
      setSelectAll () {
        setTimeout(() => {
          const value = this.selectAll
          this.documentos = this.mapSelected(this.documentos, value)
          this.certidoes = this.mapSelected(this.certidoes, value)
        } , 100)
      },

      mapSelected (docs, value = true) {
        return docs.map((doc) => {
          doc.selected = value
          return doc
        })
      },

      imprimir () {
        const documentosImprimir = [
          ...this.documentos,
          ...this.certidoes,
        ].filter(item => !!item.selected)

        this.$emit('onImprimir', documentosImprimir)
      },

      verifySelectAll () {
        setTimeout(() => {
          const items = [ ...this.documentos, ...this.certidoes]
          const allItens = items.length
          const allItensSelected = items.filter(item => item.selected ).length

          this.selectAll = (allItens == allItensSelected)
        }, 100)
      },

      getName (tag) {
        const valores = {
          processo_autuacao_sofia: 'Processo autuação',
          processo_autuacao_assinado_sofia: 'Processo autuação',
          capa_sofia: 'Capa',
          memorial_sofia: 'Memorial',
          certidoes_sofia: 'Certidões',
          edital_proclamas_sofia: 'Edital Proclamas',
          outras_certidoes_sofia: 'Outras Certidões',
          cumprimento_sofia: 'Cumprimento',
          certidao_habilitacao_sofia: 'Certidão Habilitação'
        }

        return valores[tag] || tag
      }
    }
  }
</script>

<style scoped lang="scss">
  .ModalImpressao {
    &--border {
      border-color: #000;
    }
  }
</style>
